import { render, staticRenderFns } from "./Step_6.vue?vue&type=template&id=76a47c58"
import script from "./Step_6.vue?vue&type=script&lang=js"
export * from "./Step_6.vue?vue&type=script&lang=js"
import style0 from "./Step_6.vue?vue&type=style&index=0&id=76a47c58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports